import { call, put, takeEvery, select } from 'redux-saga/effects'
import { push } from 'react-router-redux'

import queryString from 'query-string'
import { newSearchSelector, availableSelector, querySelector } from 'selectors'
import * as api from 'api'
import {
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_ERROR,
  FETCH_SUGGESTIONS,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_ERROR,
  LOCATION_CHANGE,
} from 'actionTypes'

function* search({ query, available }) {
  try {
    const results = yield call(api.search, query, available)
    yield put({ type: SEARCH_SUCCESS, results, query, available })
  } catch ({ message }) {
    yield put({ type: SEARCH_ERROR, message, query, available })
  }
}

function* fetchSuggestions({ suggestionType, value }) {
  try {
    const suggestions = yield call(api.fetchSuggestions, suggestionType, value)
    yield put({
      type: FETCH_SUGGESTIONS_SUCCESS,
      suggestionType,
      value,
      suggestions,
    })
  } catch ({ message }) {
    yield put({ type: FETCH_SUGGESTIONS_ERROR, suggestionType, value, message })
  }
}

function* updateUrl({ query, available, triggerNavigation }) {
  if (triggerNavigation) {
    const search = {
      query: query.length ? query : undefined,
      available,
    }
    yield put(push(`/?${queryString.stringify(search)}`))
  }
}

function* onLocationChange() {
  const newSearch = yield select(newSearchSelector)
  if (newSearch) {
    const query = yield select(querySelector)
    const available = yield select(availableSelector)
    yield put({ type: SEARCH, query, available, triggerNavigation: false })
  }
}

function* saga() {
  yield takeEvery(SEARCH, search)
  yield takeEvery(SEARCH, updateUrl)
  yield takeEvery(FETCH_SUGGESTIONS, fetchSuggestions)
  yield takeEvery(LOCATION_CHANGE, onLocationChange)
}

export default saga



// WEBPACK FOOTER //
// ./src/sagas/search.js